/** Gets if the given object is an object (and not Array or Date). */
const isRealObj = obj => obj && typeof obj === 'object' && !(obj instanceof Date) && !Array.isArray(obj);

/** Gets if given object is object type and not null. */
const isObj = obj => typeof obj === 'object' && obj !== null;

/**
 * Tries to find the given prop on the object at any level, including looking through arrays.
 *
 * @param {object} obj - an object to search
 * @param {string} prop - name of property to find in object
 */
const deepFindProp = (obj, prop) => {
    let foundVal = undefined;
    if (!isRealObj(obj)) {
        return foundVal;
    }

    Object.keys(obj).forEach(key => {
        if (foundVal !== undefined) { return; }

        const val = obj[key];

        if (key === prop) { // found matching property on current obj
            foundVal = val;
            return;
        }

        if (Array.isArray(val)) {
            // loop through elements and, if they're objects, try to find one that has the desired prop
            foundVal = val.find(innerVal => (isRealObj(innerVal) && deepFindProp(innerVal, prop)) !== undefined);
            return;
        }

        if (isRealObj(val)) {
            // see if it has the matching prop
            foundVal = deepFindProp(val, prop);
        }
    })
    return foundVal;
}

module.exports = {
    isRealObj,
    isObj,
}